<footer class="footer">
    <div class="footer-copyright flex-row">
      <span class="mat-caption">Colegiul Medicilor din România</span>
      <span class="flex-auto"></span>
      <span class="mat-caption">Platformă informatică dezvoltată de <a href="https://www.comprami.ro" target="blank">Comp Rami S.R.L.</a></span>
    </div>
</footer>